<template>
  <f7-page ptr @ptr:refresh="refreshData" @page:reinit="getInfo">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="`/project/info/${this.projectId}`">
      </f7-nav-left>
      <f7-nav-title>选择队伍</f7-nav-title>
    </f7-navbar>
    <f7-card v-if="perms.projectEntrust">
      <f7-card-content>
        <div class="content-area">
          <f7-row no-gap>
            <f7-col class="content-area-divider">
              <f7-link :href="`/project/teamList/${projectId}`">
                <f7-icon size="2rem" icon="cicon-duiwu"></f7-icon>
                <div>
                  <span>指派队伍</span>
                </div>
              </f7-link>
            </f7-col>
            <f7-col class="content-area-divider">
              <f7-link @click="workerPopupOpen">
                <f7-icon size="2rem" icon="cicon-zhipaigongyou"></f7-icon>
                <div>
                  <span>指派工人</span>
                </div>
              </f7-link>
            </f7-col>
            <f7-col>
              <f7-link @click="forwardRelease">
                <f7-icon size="2rem" icon="cicon-renwuzhaobiao"></f7-icon>
                <div >
                  <span class="primary-text">任务招标</span>
                </div>
              </f7-link>
            </f7-col>
          </f7-row>
        </div>
      </f7-card-content>
    </f7-card>
    <div class="select-no-data" v-if="assignObj.assignType === 'none'">
      暂无选择队伍或工人
    </div>
    <div v-show="assignObj.assignType === 'company'">
      <assign-team :project-id="projectId" :perms="perms"></assign-team>
    </div>
    <div v-show="assignObj.assignType === 'worker'">
      <assign-worker :project-id="projectId" :perms="perms"></assign-worker>
    </div>
    <div v-show="assignObj.assignType === 'publish'">
      <assign-release
        :project-id="projectId"
        :project-type="assignObj.type"
        :perms="perms">
      </assign-release>
    </div>
  </f7-page>
</template>
<script>
import { getAssignInfo } from '@/api/team/worker';
import bus from '@/util/bus';
import { createToast } from '@/util/compUtils';
import AssignTeam from './assignTeam';
import AssignWorker from './assignWorker';
import AssignRelease from './assignRelease';

export default {
  props: ['projectId'],
  components: {
    AssignTeam,
    AssignWorker,
    AssignRelease,
  },
  data() {
    return {
      assignObj: '',
      perms: {},
    };
  },
  created() {
    bus.$on('refreshAssign', () => {
      this.getInfo();
    });
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getInfo()]).then(() => done());
    },
    getInfo() {
      getAssignInfo({ projectId: this.projectId }).then((result) => {
        if (result.code === 0) {
          this.assignObj = result.data || {};
          this.perms = result.perms || {};
        }
      });
    },
    workerPopupOpen() {
      bus.$emit('workerPopupOpened', true);
    },
    forwardRelease() {
      if (this.assignObj.assignType === 'none') {
        let releaseContext = null;
        if (this.assignObj.type === 'assistProject') {
          releaseContext = 'releaseAssist';
        } else if (this.assignObj.type === 'normalProject') {
          releaseContext = 'releaseNormal';
        }
        if (releaseContext) {
          this.$f7router.navigate(`/project/${releaseContext}/${this.projectId}`);
        } else {
          createToast(this, '根任务不允许发布');
        }
      } else {
        createToast(this, '此任务已经指派或者发布');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .content-area {
    text-align: center;
    line-height: 150%;
  }

  .label-text {
    color: $second-font-color;
    font-size: 0.8rem;
  }

  .content-area-divider {
     border-right: 0.05rem dashed $border-color;
  }

  .select-no-data {
    border-radius: 0.5rem;
    background-color: $panel-bg-color;
    text-align: center;
    line-height: 8rem;
    height: 8rem;
    font-size: 1rem;
    padding: 0rem 10px;
    color: #B6B6B6;
  }

</style>



// WEBPACK FOOTER //
// src/pages/team/assign.vue